const stockStatistics = () =>
  import('@/views/main/ybwave/stockStatistics/stockStatistics.vue')
export default {
  path: '/main/ybwave/stockStatistics',
  name: 'stockStatistics',
  component: stockStatistics,
  children: []
}
